/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import SelectField from 'forms/shared/fields/select'
import { Field, formValueSelector } from 'redux-form'
import InputWithPrefixField from 'forms/shared/fields/input-with-prefix'
import TextField from 'forms/shared/fields/text'
import MultipleSelectDisable from 'forms/shared/fields/select-multi-disable'
import MultiSelect from 'forms/shared/fields/filter-select-multi'
import TextArea from 'forms/shared/fields/text-area'
import categoryActions from 'actions/categories/actions'
import spaceFunctionActions from 'actions/spaceFunction/actions'
import spaceData from 'constants/space-data'
import {
  FORM_ERROR_CLASS,
  INPUT_ERROR_CLASS,
  MERCHANT_FORM_LABEL,
  MERCHANT_INPUT_CLASS,
  REACT_SELECT_CUSTOM_STYLE_MERCHANT,
} from 'constants/css-style'

const SpaceDetails = ({
  fetchCategoryOptions,
  categories,
  fetchCategorySpaceFunction,
  tags,
  categoryId,
  currency,
  venues,
  venueId,
  fetchSpaceBuildings,
  buildings,
  buildingId,
}) => {
  const [dropdownBuilding, setDropdownBuilding] = useState()
  const [dropdownBuildingType, setDropdownBuildingType] = useState()

  useEffect(() => {
    fetchCategoryOptions()
  }, [])

  useEffect(() => {
    categoryId && fetchCategorySpaceFunction(categoryId)
  }, [categoryId])

  useEffect(() => {
    if (buildingId) {
      const buildingSelected = buildings.find((building) => building.id === buildingId)
      const buildingtypes = buildingSelected.buildingUses.map((item) => ({
        value: item.id,
        label: item.name,
      }))
      setDropdownBuildingType(buildingtypes)
    }
  }, [buildingId])

  useEffect(() => {
    if (buildings) {
      setDropdownBuilding(buildings.map((bd) => ({ value: bd.id, label: bd.name })))
    }
  }, [buildings])

  const handleSelectValues = (key) => {
    // eslint-disable-next-line default-case
    switch (
      key // eslint-disable-line
    ) {
      case 'category': {
        const values = categories.map((c) => {
          const category = {
            label: c.label,
            value: c.id,
          }
          return category
        })
        return values
      }
    }
  }
  useEffect(() => {
    if (venueId) {
      const venue = venues.find((v) => v.value === venueId)
      venue && fetchSpaceBuildings({ spaceId: venue.place_id })
    }
  }, [venueId])
  return (
    <div className="details">
      <p className="font-bold text-primary-gray text-xl">Space Details</p>
      <div className="flex flex-wrap">
        <div className="w-1/2">
          <div className="w-full flex items-center">
            <Field
              name="category_id"
              label={'Space Category'}
              labelClassName={MERCHANT_FORM_LABEL}
              groupClassName="my-3 w-1/2"
              placeholder="Select a Space Category"
              options={handleSelectValues('category')}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={SelectField}
            />
          </div>
          <Field
            name="tags"
            label={'Space Functions'}
            labelClassName={MERCHANT_FORM_LABEL}
            groupClassName="my-3 w-full"
            options={tags}
            selectStyles={REACT_SELECT_CUSTOM_STYLE_MERCHANT}
            inputClassName={'select text-xs'}
            placeholder={'Select Space Functions'}
            inputErrorClassName={INPUT_ERROR_CLASS}
            errorClassName={FORM_ERROR_CLASS}
            component={MultiSelect}
          />
        </div>
        <div className="w-1/2 pl-10">
          <Field
            type={'text'}
            name={'description'}
            label={'Space Description'}
            groupClassName="my-3"
            rows={5}
            labelClassName={MERCHANT_FORM_LABEL}
            inputClassName={'border w-full rounded text-xs p-2'}
            inputErrorClassName={INPUT_ERROR_CLASS}
            errorClassName={FORM_ERROR_CLASS}
            component={TextArea}
          />
        </div>
        <div className="w-1/2 flex">
          <div className="w-5/12">
            <Field
              type={'number'}
              name={'min_guests'}
              label={'Guest Range'}
              groupClassName="my-3 w-full"
              placeholder={'Min. no of Guests'}
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={TextField}
            />
          </div>
          <div className="w-1/6 flex items-end my-3 justify-center">
            <span>to</span>
          </div>
          <div className="w-5/12">
            <Field
              type={'number'}
              name={'max_guests'}
              label={'Guest Range'}
              groupClassName="my-3 w-full"
              placeholder={'Max. no of Guests'}
              labelClassName={`${MERCHANT_FORM_LABEL} invisible`}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={TextField}
            />
          </div>
        </div>
      </div>
      {categoryId && categoryId === 4 ? (
        <div>
          <div className="flex items-center">
            <Field
              name="building_id"
              label={'BUILDING NAME'}
              labelClassName={`mb-1 ${MERCHANT_FORM_LABEL}`}
              groupClassName="my-3 w-1/2"
              options={dropdownBuilding}
              inputClassName={'select text-xs outline-none '}
              styles={REACT_SELECT_CUSTOM_STYLE_MERCHANT}
              inputErrorClassName={FORM_ERROR_CLASS}
              errorClassName="text-red-500 text-xs italic"
              component={SelectField}
            />
            <Field
              name="building_type"
              label={'BUILDING TYPE'}
              labelClassName={`mb-1 ${MERCHANT_FORM_LABEL}`}
              groupClassName="my-3 w-1/2 pl-10"
              options={dropdownBuildingType}
              defaultValue={dropdownBuildingType || null}
              errorClassName="text-red-500 text-xs italic"
              component={MultipleSelectDisable}
            />
          </div>
          <div className="flex">
            <div className="w-1/2 pr-1 flex">
              <Field
                type={'number'}
                name={'floor_size'}
                label={'FLOOR SIZE'}
                placeholder="Floor size"
                groupClassName="my-3 w-5/12 pr-1"
                labelClassName={`${MERCHANT_FORM_LABEL} mb-4`}
                inputClassName={`${MERCHANT_INPUT_CLASS} px-1 py-1`}
                inputerrorClassName={FORM_ERROR_CLASS}
                errorClassName="text-red-500 text-xs italic"
                component={TextField}
              />
              <Field
                name="area_unit"
                label={'AREA UNIT'}
                labelClassName={`mb-4 ${MERCHANT_FORM_LABEL}`}
                groupClassName="my-3 w-3/12 pl-1"
                options={[
                  { value: 'sqft', label: 'sqft' },
                  { value: 'sqm', label: 'sqm' },
                ]}
                inputClassName={'select text-xs outline-none '}
                styles={REACT_SELECT_CUSTOM_STYLE_MERCHANT}
                inputErrorClassName={FORM_ERROR_CLASS}
                errorClassName="text-red-500 text-xs italic"
                component={SelectField}
              />
              <Field
                name="floor_level"
                label={'FLOOR LEVEL'}
                labelClassName={`mb-4 ${MERCHANT_FORM_LABEL}`}
                groupClassName="my-3 w-4/12 pl-1"
                options={spaceData.officeSpaceFloorLevel}
                inputClassName={'select text-xs outline-none '}
                styles={REACT_SELECT_CUSTOM_STYLE_MERCHANT}
                inputErrorClassName={FORM_ERROR_CLASS}
                errorClassName="text-red-500 text-xs italic"
                component={SelectField}
              />
            </div>
            <div className="w-1/2 flex pl-10">
              <Field
                type={'number'}
                placeholder="Floor number"
                name={'floor_number'}
                label={'FLOOR NUMBER'}
                groupClassName="my-3 w-1/2 pl-1 "
                labelClassName={`${MERCHANT_FORM_LABEL} mb-4`}
                inputClassName={`${MERCHANT_INPUT_CLASS} px-1 py-1`}
                inputerrorClassName={FORM_ERROR_CLASS}
                errorClassName="text-red-500 text-xs italic"
                component={TextField}
              />
              <Field
                name="furnishing_level"
                label={'FURNISHING LEVEL'}
                labelClassName={`mb-4 ${MERCHANT_FORM_LABEL}`}
                groupClassName="my-3 w-1/2 pl-1"
                options={[
                  { value: 'fullyFitted', label: 'Fully Fitted' },
                  { value: 'semiFurnished', label: 'Semi Furnished' },
                  { value: 'bare', label: 'Bare' },
                ]}
                inputClassName={'select text-xs outline-none '}
                styles={REACT_SELECT_CUSTOM_STYLE_MERCHANT}
                inputErrorClassName={FORM_ERROR_CLASS}
                errorClassName="text-red-500 text-xs italic"
                component={SelectField}
              />
            </div>
          </div>
          <div className="flex">
            <Field
              type={'date'}
              name={'date_available'}
              label={'DATE AVAILABLE'}
              placeholder="Date available"
              groupClassName="my-3 w-1/2"
              labelClassName={`${MERCHANT_FORM_LABEL} mb-4`}
              inputClassName={`${MERCHANT_INPUT_CLASS} px-1 py-1`}
              inputerrorClassName={FORM_ERROR_CLASS}
              errorClassName="text-red-500 text-xs italic"
              component={TextField}
            />
            <Field
              type={'number'}
              name={'asking_rent'}
              label={'ASKING RENT'}
              placeholder="Asking rent"
              groupClassName="my-3 w-1/2 pl-10"
              labelClassName={`${MERCHANT_FORM_LABEL} mb-4`}
              inputClassName={`${MERCHANT_INPUT_CLASS} px-1 py-1`}
              inputerrorClassName={FORM_ERROR_CLASS}
              errorClassName="text-red-500 text-xs italic"
              component={TextField}
            />
          </div>
          <div className="flex">
            <Field
              type={'number'}
              name={'achievable_rent'}
              label={'ACHIEVABLE RENT'}
              placeholder="Achievable rent"
              groupClassName="my-3 w-1/2"
              labelClassName={`${MERCHANT_FORM_LABEL} mb-4`}
              inputClassName={`${MERCHANT_INPUT_CLASS} px-1 py-1`}
              inputerrorClassName={FORM_ERROR_CLASS}
              errorClassName="text-red-500 text-xs italic"
              component={TextField}
            />
            <Field
              type={'number'}
              name={'price_per_square_meter'}
              label={'PRICE PER SQUARE METER'}
              placeholder="Price per square meter"
              groupClassName="my-3 w-1/2 pl-10"
              labelClassName={`${MERCHANT_FORM_LABEL} mb-4`}
              inputClassName={`${MERCHANT_INPUT_CLASS} px-1 py-1`}
              inputerrorClassName={FORM_ERROR_CLASS}
              errorClassName="text-red-500 text-xs italic"
              component={TextField}
            />
          </div>
        </div>
      ) : (
        <div className="price w-full flex">
          <div className="w-1/3 flex justify-start">
            <Field
              type="number"
              name="hour_price"
              placeHolder="Hourly Price..."
              prefix={currency.name}
              label="Hourly Price"
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputGroupClassName=""
              groupClassName="my-3"
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={InputWithPrefixField}
            />
          </div>
          <div className="w-1/3 flex justify-center">
            <Field
              type="number"
              name="daily_price"
              placeHolder="Daily Price..."
              prefix={currency.name}
              label="Daily Price"
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputGroupClassName=""
              groupClassName="my-3"
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={InputWithPrefixField}
            />
          </div>
          <div className="w-1/3 flex justify-end">
            <Field
              type="number"
              name="monthly_price"
              placeHolder="Monthly Price..."
              prefix={currency.name}
              label="Monthly Price"
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputGroupClassName=""
              groupClassName="my-3"
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={InputWithPrefixField}
            />
          </div>
        </div>
      )}
    </div>
  )
}

SpaceDetails.propTypes = {
  fetchCategoryOptions: PropTypes.func,
  categories: PropTypes.array,
  fetchCategorySpaceFunction: PropTypes.func,
  tags: PropTypes.array,
  categoryId: PropTypes.number,
  currency: PropTypes.object,
  venueId: PropTypes.number,
  venues: PropTypes.array,
  fetchSpaceBuildings: PropTypes.func,
  buildings: PropTypes.array,
  buildingId: PropTypes.number,
}

const mapStateToProps = ({ merchant, category, spaceFunctions, venue, ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    categories: category.options,
    tags: spaceFunctions.categorySpaceFunction.tags,
    categoryId: selector(state, 'category_id'),
    currency: venue.details.place.currency,
    venues: merchant.venueList,
    venueId: selector(state, 'venue_id'),
    buildings: spaceFunctions.buildingList,
    buildingId: selector(state, 'building_id'),
  }
}

const mapDispatchToProps = {
  fetchCategoryOptions: categoryActions.fetchCategoryOptions,
  fetchCategorySpaceFunction: spaceFunctionActions.fetchCategorySpaceFunction,
  fetchSpaceBuildings: spaceFunctionActions.fetchSpaceBuildings,
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceDetails)
